function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import Bem, { decl } from '@yandex-lego/i-bem-react';
export default decl({
  block: 'user-pic',
  elem: 'camera',
  willInit: function willInit() {
    this.state = _objectSpread({
      retpath: ''
    }, this.props);
  },
  didMount: function didMount() {
    this.setState({
      retpath: "&retpath=".concat(encodeURIComponent(window.location.href))
    });
  },
  content: function content() {
    var href = "".concat(this.props.cameraURL, "?origin=").concat(this.props.origin).concat(this.state.retpath);
    return React.createElement(Bem, {
      tag: "a",
      elem: "link",
      href: href,
      attrs: {
        'aria-hidden': 'true',
        tabIndex: -1
      },
      key: "Link"
    });
  }
}, {
  propTypes: {
    origin: PropTypes.string,
    cameraURL: PropTypes.string
  },
  defaultProps: {
    origin: 'userpic',
    cameraURL: 'https://passport.yandex.ru/profile/public'
  }
});